<script lang="ts">
  import {t} from '../i18n'
  import {modal} from '../stores/modal'
  import {user} from '../stores/user'
  import PasswordRecovery from './PasswordRecovery.svelte'
  import Register from './Register.svelte'
  import LoginSocial from './LoginSocial.svelte'
  import api from '../api/api'
  import type {User} from '../types'
  import {navigate} from 'svelte5-router'
  import FacebookButton from './FacebookButton.svelte'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import ValidationMessage from '../shared/ValidationMessage.svelte'
  import GoogleButton from '../../src/authentication/GoogleButton.svelte'

  let authorization = {email: '', password: ''}
  let errors: string[] | null = null

  async function submit(e: Event) {
    e.preventDefault()
    try {
      const response = await api.post<User>('/login', {user: authorization})
      modal.close()
      $user = response
      navigate('/')
    } catch (response: any) {
      errors = response.errors
    }
  }

  function openForgotPass(e: Event) {
    e.preventDefault()
    modal.show(PasswordRecovery)
  }

  function openRegister(e: Event) {
    e.preventDefault()
    modal.show(Register)
  }

  function openLoginSocial(e: Event) {
    e.preventDefault()
    modal.show(LoginSocial)
  }
</script>


<ModalTemplate size="tiny">
  <div class="modal-content">
    <form onsubmit={submit}>
      <h2 class="reg-log-title">
        <span>{t.authorization.login.title}</span>

        <a class="register-btn" href="" onclick={openRegister}>
          {t.authorization.registration.title}
        </a>
      </h2>

      <div class="line">
        <input type="email" required placeholder={t.authorization.login.email} bind:value={authorization.email}/>
      </div>

      <div class="line">
        <input type="password" required placeholder={t.authorization.login.password}
               bind:value={authorization.password}/>

        <ValidationMessage {errors}/>
      </div>

      <div class="line">
        <button type="submit" class="ui button black">{t.authorization.login.title}</button>

        <a class="pass-recovery-link" onclick={openForgotPass}>
          {t.authorization.login.forgot_password}
        </a>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <h5>
      <a class="email-login" onclick={openLoginSocial}>{t.authorization.login.with_social}</a>
    </h5>

    <div class="soc-login">
      <FacebookButton class="icon-p-facebook" />
      <GoogleButton class="icon-p-google" />
    </div>
  </div>
</ModalTemplate>
